/**
 * Will set the page title if it exists in the route.
 */
const PageTitle = () => (next) => (action) => {
	const { type, payload } = action;

	if (type === "@@ROUTER-UPDATE" || type === "@@ROUTER-MOUNTED") {
		try {
			document.title = `${payload.matchedRoute.route.title} | Logan`;
		} catch (ermahgerd) {
			// pass
		}
	}

	next(action);
};

export default PageTitle;
